import { Business_Profile_Enum } from '@kheops/graphql';
import { useAtomValue } from 'jotai';
import { isVisibleInDiscoveryFilter } from '../search/discovery.utils';
import { currentContextAtom } from '../state';
import FilterUtils from '../search/filters/filter.utils';

export type SearchMode = 'PRODUCT' | 'COMPANY';

export default function useDiscoveryDefaultFilters(searchMode?: SearchMode): string {
  const { realm, companyId } = useAtomValue(currentContextAtom);

  if (searchMode === 'PRODUCT') {
    return `${isVisibleInDiscoveryFilter} AND ${FilterUtils.visiblePackagingsForBuyerFilter(companyId)}`;
  }

  return realm === Business_Profile_Enum.Buyer ? 'business_profile:SUPPLIER' : 'business_profile:BUYER';
}
